/* eslint-disable angular/controller-name */

angular.
module("dx.webapp.exam").
controller("dxExamSettingsInfoController", function ExamSettingsInfoController(
	DX_GRADING_TYPES,
	DX_DURATION_SETTING,
	DX_SPELLCHECKSETTING,
	DX_TEXT_TO_SPEECH_SETTING,
	DX_USB_AUDIO_SETTING,
	DX_IMMERSIVE_READER_SETTING,
	dxLocalize,
	dxConvertDuration
) {
	"use strict";

	this.DX_GRADING_TYPES = DX_GRADING_TYPES;
	this.DX_DURATION_SETTING = DX_DURATION_SETTING;
	this.DX_SPELLCHECKSETTING = DX_SPELLCHECKSETTING;
	this.DX_TEXT_TO_SPEECH_SETTING = DX_TEXT_TO_SPEECH_SETTING;
	this.DX_USB_AUDIO_SETTING = DX_USB_AUDIO_SETTING;
	this.DX_IMMERSIVE_READER_SETTING = DX_IMMERSIVE_READER_SETTING;

	var durationTime = dxConvertDuration.convertNsToTime(this.exam.duration);

	this.durationSettingDescription = dxLocalize.
		get("ExamSettingsInfo.DurationSetting.Description").
		format(durationTime.hours, durationTime.minutes);
});
